module.exports = __webpack_public_path__ + "img/logo-texte.a9de05b4.png";